import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class PopupSystemUpgrade extends Vue {
  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }
  public get getCurrentLanguage(): string {
    return localStorage.getItem('currentLanguage');
  }

  dontDisplayToday() {
    const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
    localStorage.setItem('DDT_DATE', today);
  }

  redirect() {
    window.open('https://event-us.kr/saltlux/event/106801', '_target');
  }
}
